import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as customizationPaths } from "@/types/api/customization/schema.gen"

const client = createApiClient<customizationPaths>({
  baseUrl: `${env.VITE_API2_URL}/customization`
})

// Vanilla API client
export const $customizationApiClient = client.vanillaClient

// React-Query client
export const $rqCustomizationApiClient = createClient(client.rqClient)
